module.exports = __webpack_public_path__ + "static/media/btn-program-carousel-left.3a16c89b.svg";